import { DeviceState } from '@era/appmanagement-sdk';
import { ErrorModel } from '@era/app';
export const DEVICE_APPLICATION_STATE_FEATURE_KEY = 'deviceApplicationState';

export interface DeviceApplicationStateStoreState {
  loaded: boolean;
  error?: ErrorModel;
  entities: Record<string, DeviceState>;
}

export const initialDeviceApplicationStateStoreState: DeviceApplicationStateStoreState = {
  loaded: false,
  error: undefined,
  entities: {},
};
